import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ThemeModule } from './views/theme/theme.module';
import {  NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptor } from './core/_interceptor/interceptor';
import { AuthGuard, CanLoginActivate } from './core/_guards/auth.guard';
import { PartialsModule } from './views/partials/partials.module';
import { CookieService } from 'ngx-cookie-service';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { MatSelectModule } from '@angular/material/select'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire/';
import { environment } from 'src/environments/environment';
import { MessagingService } from './core/_services/messaging.service';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#326395',
  fgsColor: '#326395',
  pbColor: '#326395',
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ThemeModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    
    ToastrModule.forRoot({
      timeOut: 3000,
      // positionClass: 'toast-bottom-right',
    preventDuplicates: true,
    }),
    HttpClientModule,
    PartialsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatSelectModule,
    MatFormFieldModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [
    AuthGuard,
    CookieService,
    CanLoginActivate,
   { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
   MessagingService
   
    // ToastrModule.forRoot()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
